export type Language = 'pt' | 'en';

export type T = {
  appName: string;
  signOut: string;
  themeToggleDark: string;
  themeToggleLight: string;
  heroTitle1: string;
  heroTitle2: string;
  heroSubtitle: string;
  createRoomNow: string;
  namePlaceholder: string;
  card1Title: string; card1Desc: string;
  card2Title: string; card2Desc: string;
  card3Title: string; card3Desc: string;
  card4Title: string; card4Desc: string;
  adTitle: string; adDesc: string; adTooltip: string;
  donateCardTitle: string;
  donateCardDesc: string;
  donateModalTitle: string;
  donateModalSubtitle: string;
  donateKeyLabel: string;
  donateCopyKey: string;
  donateKeyCopied: string;
  donateClose: string;
  maintenanceMsg: string;
  maintenanceCreateBlocked: string;
  statsUsersLabel: string;
  statsRoomsLabel: string;
  lobbyTitle: string;
  lobbySubtitle: string;
  newRoomCardTitle: string;
  roomNameLabel: string;
  roomNamePlaceholder: string;
  creatingBtn: string;
  createRoomBtn: string;
  joinRoomCardTitle: string;
  roomCodeLabel: string;
  roomCodePlaceholder: string;
  joinBtn: string;
  errorRoomName: string;
  roomCreatedMsg: string;
  errorRoomCode: string;
  roomNotFound: string;
  backToLobby: string;
  votesRevealedMsg: string;
  storyUpdatedMsg: string;
  linkCopiedMsg: string;
  copyLinkBtn: string;
  closeRoomBtn: string;
  leaveBtn: string;
  currentStoryLabel: string;
  storyPlaceholder: string;
  setStoryBtn: string;
  yourChoice: string;
  revealVotesBtn: string;
  revealWithCount: (n: number) => string;
  newRoundBtn: string;
  participantsTitle: (n: number) => string;
  shareWithTeam: string;
  adminBadge: string;
  votesCounter: (count: number, total: number) => string;
  finalEstimate: string;
  average: string;
  votesLabel: string;
  historyTitle: (n: number) => string;
  noTitle: string;
  discussionTitle: string;
  consensusMsg: string;
  whyVoted: string;
  reactions: { emoji: string; label: string }[];
  waitingStory: string;
  throwAt: (name: string) => string;
  reactAs: string;
  enterNameTitle: string;
  enterNameSubtitle: string;
  joinRoomBtn: string;
  votedBadge: string;
  deck: {
    fibonacci: string;
    tshirt: string;
    selectorLabel: string;
    changeConfirmTitle: string;
    changeConfirmBody: string;
    changeConfirmCta: string;
    cancel: string;
  };
  tshirtCard: {
    xs: string;
    s: string;
    m: string;
    l: string;
    xl: string;
    xxl: string;
  };
  mostCommonSize: string;
};

export const translations: Record<Language, T> = {
  en: {
    appName: 'POKER 4 DEVS',
    signOut: 'Sign out',
    themeToggleDark: 'd',
    themeToggleLight: 'm',

    heroTitle1: 'Simple Planning Poker',
    heroTitle2: 'for agile teams',
    heroSubtitle: 'Create a private room, invite your team and estimate stories in real time — fast, free and collaborative.',
    createRoomNow: 'Create room now ->',
    namePlaceholder: 'Your name...',
    card1Title: 'Real-time estimates',
    card1Desc: 'All votes are synced instantly to help your team reach a decision.',
    card2Title: 'Free & no sign-up',
    card2Desc: 'No account, no install, no hassle.',
    card3Title: 'Private rooms by link',
    card3Desc: 'Share an exclusive room only with the people in the session.',
    card4Title: 'Estimate history',
    card4Desc: 'Review past votes and track decisions made by your team.',
    adTitle: 'Advertise here',
    adDesc: 'Reach an audience in tech, product and agile management.',
    adTooltip: 'Advertise here',
    donateCardTitle: 'Support the project',
    donateCardDesc: 'Enjoying it? Buy me a coffee — every PIX helps keep the rooms free!',
    donateModalTitle: 'Support POKER 4 DEVS',
    donateModalSubtitle: 'Scan the QR code in your bank app or copy the PIX key below.',
    donateKeyLabel: 'PIX copy & paste key',
    donateCopyKey: 'Copy PIX key',
    donateKeyCopied: 'PIX key copied!',
    donateClose: 'Close',
    maintenanceMsg: 'Daily cleanup in progress — rooms are being reset (3 AM São Paulo time).',
    maintenanceCreateBlocked: 'Cannot create rooms during the daily cleanup. Try again in a moment.',
    statsUsersLabel: 'users joined',
    statsRoomsLabel: 'rooms created',

    lobbyTitle: 'Lobby',
    lobbySubtitle: 'Create a new room or join an existing one',
    newRoomCardTitle: 'New Room',
    roomNameLabel: 'Room name',
    roomNamePlaceholder: 'e.g. Sprint 42 Planning',
    creatingBtn: 'Creating...',
    createRoomBtn: 'Create Room',
    joinRoomCardTitle: 'Join Room',
    roomCodeLabel: 'Room code or link',
    roomCodePlaceholder: 'Paste room ID here',
    joinBtn: 'Join',
    errorRoomName: 'Enter a room name',
    roomCreatedMsg: 'Room created!',
    errorRoomCode: 'Paste the room code',

    roomNotFound: 'Room not found',
    backToLobby: 'Back to Lobby',
    votesRevealedMsg: 'Votes revealed!',
    storyUpdatedMsg: 'Story updated!',
    linkCopiedMsg: 'Link copied!',
    copyLinkBtn: 'Copy invite link',
    closeRoomBtn: 'Close Room',
    leaveBtn: 'Leave',
    currentStoryLabel: 'Current story',
    storyPlaceholder: 'e.g. As a user, I want...',
    setStoryBtn: 'Set',
    yourChoice: 'Your choice',
    revealVotesBtn: 'Reveal Votes',
    revealWithCount: (n: number) => `Reveal (${n} votes)`,
    newRoundBtn: 'New Round',
    participantsTitle: (n: number) => `Participants (${n})`,
    shareWithTeam: 'Share with your team',
    adminBadge: 'Admin',
    votesCounter: (count: number, total: number) => `${count}/${total} votes`,

    finalEstimate: 'Final Estimate',
    average: 'Average',
    votesLabel: 'Votes',

    historyTitle: (n: number) => `History (${n} rounds)`,
    noTitle: '(no title)',

    discussionTitle: 'Discussion suggestion',
    consensusMsg: 'Consensus! Everyone voted the same — move to the next one!',
    whyVoted: 'why did you vote',

    reactions: [
      { emoji: '🐛', label: 'Bug!' },
      { emoji: '🔥', label: 'This is fine' },
      { emoji: '🚀', label: 'Ship it!' },
      { emoji: '💀', label: 'Dead code' },
      { emoji: '☕', label: 'Need coffee' },
      { emoji: '💩', label: 'WTF' },
      { emoji: '🤔', label: 'Hmm...' },
      { emoji: '💡', label: 'Eureka!' },
      { emoji: '😤', label: 'Works on my machine' },
      { emoji: '🤡', label: 'Spaghetti code' },
      { emoji: '🏁', label: 'Sprint done!' },
      { emoji: '💯', label: 'Perfect' },
    ],

    waitingStory: 'Waiting for story...',
    throwAt: (name: string) => `Throw at ${name}`,
    reactAs: 'React',

    enterNameTitle: 'Enter your name',
    enterNameSubtitle: 'Tell the team who is joining the room',
    joinRoomBtn: 'Join Room',
    votedBadge: 'Voted',
    deck: {
      fibonacci: 'Fibonacci',
      tshirt: 'T-shirt',
      selectorLabel: 'Deck',
      changeConfirmTitle: 'Change the deck?',
      changeConfirmBody: 'Changing the deck will reset the current round. Continue?',
      changeConfirmCta: 'Yes, change',
      cancel: 'Cancel',
    },
    tshirtCard: {
      xs: 'XS',
      s: 'S',
      m: 'M',
      l: 'L',
      xl: 'XL',
      xxl: 'XXL',
    },
    mostCommonSize: 'Most common size',
  },

  pt: {
    appName: 'POKER 4 DEVS',
    signOut: 'Sair',
    themeToggleDark: 'd',
    themeToggleLight: 'm',

    heroTitle1: 'Planning Poker simples',
    heroTitle2: 'para times ágeis',
    heroSubtitle: 'Crie uma sala privada, convide sua equipe e estime histórias em tempo real de forma rápida, gratuita e colaborativa.',
    createRoomNow: 'Criar sala agora ->',
    namePlaceholder: 'Seu nome...',
    card1Title: 'Estimativas em tempo real',
    card1Desc: 'Todos os votos são sincronizados instantaneamente para facilitar a decisão do time.',
    card2Title: 'Grátis e sem cadastro',
    card2Desc: 'Use sem criar conta, sem instalação e sem burocracia.',
    card3Title: 'Salas privadas por link',
    card3Desc: 'Compartilhe uma sala exclusiva apenas com quem participa da estimativa.',
    card4Title: 'Histórico de estimativas',
    card4Desc: 'Consulte votações anteriores e acompanhe as decisões tomadas pela equipe.',
    adTitle: 'Divulgue sua marca aqui',
    adDesc: 'Anuncie para um público conectado a tecnologia, produto e gestão ágil.',
    adTooltip: 'Anuncie aqui',
    donateCardTitle: 'Apoie o projeto',
    donateCardDesc: 'Curtindo? Me paga um café — cada PIX ajuda a manter as salas grátis!',
    donateModalTitle: 'Apoie o POKER 4 DEVS',
    donateModalSubtitle: 'Escaneie o QR code no seu banco ou copie a chave PIX abaixo.',
    donateKeyLabel: 'Chave PIX copia e cola',
    donateCopyKey: 'Copiar chave PIX',
    donateKeyCopied: 'Chave PIX copiada!',
    donateClose: 'Fechar',
    maintenanceMsg: 'Limpeza diária em andamento — as salas estão sendo apagadas (3h, horário de São Paulo).',
    maintenanceCreateBlocked: 'Não é possível criar salas durante a limpeza diária. Tente novamente em instantes.',
    statsUsersLabel: 'pessoas usaram',
    statsRoomsLabel: 'salas criadas',

    lobbyTitle: 'Lobby',
    lobbySubtitle: 'Crie uma nova sala ou entre em uma existente',
    newRoomCardTitle: 'Nova Sala',
    roomNameLabel: 'Nome da sala',
    roomNamePlaceholder: 'Ex: Sprint 42 Planning',
    creatingBtn: 'Criando...',
    createRoomBtn: 'Criar Sala',
    joinRoomCardTitle: 'Entrar em Sala',
    roomCodeLabel: 'Código ou link da sala',
    roomCodePlaceholder: 'Cole o ID da sala aqui',
    joinBtn: 'Entrar',
    errorRoomName: 'Digite um nome para a sala',
    roomCreatedMsg: 'Sala criada!',
    errorRoomCode: 'Cole o código da sala',

    roomNotFound: 'Sala não encontrada',
    backToLobby: 'Voltar ao Lobby',
    votesRevealedMsg: 'Votos revelados!',
    storyUpdatedMsg: 'História atualizada!',
    linkCopiedMsg: 'Link copiado!',
    copyLinkBtn: 'Copiar link de convite',
    closeRoomBtn: 'Encerrar',
    leaveBtn: 'Sair',
    currentStoryLabel: 'História atual',
    storyPlaceholder: 'Ex: Como usuário, quero...',
    setStoryBtn: 'Definir',
    yourChoice: 'Sua escolha',
    revealVotesBtn: 'Revelar Votos',
    revealWithCount: (n: number) => `Revelar (${n} votos)`,
    newRoundBtn: 'Nova Rodada',
    participantsTitle: (n: number) => `Participantes (${n})`,
    shareWithTeam: 'Compartilhe com sua equipe',
    adminBadge: 'Admin',
    votesCounter: (count: number, total: number) => `${count}/${total} votos`,

    finalEstimate: 'Estimativa Final',
    average: 'Média',
    votesLabel: 'Votos',

    historyTitle: (n: number) => `Histórico (${n} rodadas)`,
    noTitle: '(sem título)',

    discussionTitle: 'Sugestão de discussão',
    consensusMsg: 'Consenso! Todo mundo votou igual — pode passar para a próxima!',
    whyVoted: 'por que você votou',

    reactions: [
      { emoji: '🐛', label: 'Bug!' },
      { emoji: '🔥', label: 'Tá pegando fogo' },
      { emoji: '🚀', label: 'Bora lá!' },
      { emoji: '💀', label: 'Código morto' },
      { emoji: '☕', label: 'Preciso de café' },
      { emoji: '💩', label: 'WTF' },
      { emoji: '🤔', label: 'Hmm...' },
      { emoji: '💡', label: 'Eureka!' },
      { emoji: '😤', label: 'Funciona na minha máquina' },
      { emoji: '🤡', label: 'Código espaguete' },
      { emoji: '🏁', label: 'Sprint feita!' },
      { emoji: '💯', label: 'Perfeito' },
    ],

    waitingStory: 'Aguardando história...',
    throwAt: (name: string) => `Jogar em ${name}`,
    reactAs: 'Reagir',

    enterNameTitle: 'Digite seu nome',
    enterNameSubtitle: 'Diga ao time quem está entrando na sala',
    joinRoomBtn: 'Entrar na Sala',
    votedBadge: 'Votou',
    deck: {
      fibonacci: 'Fibonacci',
      tshirt: 'Camiseta',
      selectorLabel: 'Baralho',
      changeConfirmTitle: 'Trocar o baralho?',
      changeConfirmBody: 'Trocar o baralho vai resetar a votação atual. Continuar?',
      changeConfirmCta: 'Sim, trocar',
      cancel: 'Cancelar',
    },
    tshirtCard: {
      xs: 'PP',
      s: 'P',
      m: 'M',
      l: 'G',
      xl: 'GG',
      xxl: 'XG',
    },
    mostCommonSize: 'Tamanho mais comum',
  },
};
